import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";

const Jardtable = props => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    var today = new Date();
    today.setMonth(today.getMonth()+7);
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // today.setMonth(today.getMonth()-7)
  // Calculate the date 6 months from now
  const sixMonthsFromNow = new Date();
  sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);

  return (
    <div>
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <div className="w-1/2">
            <h2 className="text-base font-semibold text-slate-800">کۆی بەهای کۆگا</h2>
          </div>
          <div className="w-1/2">
            <h3 className="text-base font-normal text-slate-700">{numberbeautify(iqd_rounding(initState?.stock_amount))} IQD</h3>
          </div>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                ناوی کاڵا
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                باڕکۆد
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                نرخ
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                بڕی ماوە
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                بەرواری بەسەرچوون
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
              {initState.stok.map((lis)=>(
              <tr key={lis.item_id} className={
                moment(lis.item_exp_date).isValid() ?
                  new Date(lis.item_exp_date) < new Date() ? "bg-red-400" :
                  new Date(lis.item_exp_date) < sixMonthsFromNow ? "bg-yellow-400" :
                  "bg-white"
                : "bg-white"
              }>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_name}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_barcode}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {numberbeautify(iqd_rounding(money_rounding(lis.item_price)))} IQD
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {money_rounding(lis.item_qty)}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.item_exp_date}
                </td>
              </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Jardtable